import ChildrensRoomExperience from "@inter-ikea-range/childrens-room-experience";
import Toys from "@inter-ikea-range/toys";
import Trofast from "@inter-ikea-range/trofast";

import type { EnvironmentSettings, Experience } from "@inter-ikea-space-platform/experience";

// room experience
export const childrensRoomExperience = (settings: EnvironmentSettings) =>
  ChildrensRoomExperience(settings);

// range packages
export const childrensRoomPackages = (settings: EnvironmentSettings): Experience[] => [
  Toys(settings),
  Trofast(settings),
];
